<doka-modal-wrapper (close)="closeModal()">
  <ng-template #title>{{
    itemTemplate() == undefined
      ? ("MasterData.TemplateSlideOver.CreateTitle" | i18nextEager)
      : ("MasterData.TemplateSlideOver.UpdateTitle" | i18nextEager)
  }}</ng-template>

  <ng-template #content>
    <form [formGroup]="form">
      <div class="flex flex-col gap-lg">
        <doka-select
          class="w-full"
          formControlName="countryId"
          [label]="'MasterData.TemplateSlideOver.Country' | i18nextEager"
          [placeholder]="'Common.Select' | i18nextEager"
        >
          @for (country of countries.value()?.data; track country.id) {
            <doka-select-option [value]="country.id" [label]="country.countryName"></doka-select-option>
          }
        </doka-select>

        <doka-select
          class="w-full"
          formControlName="isoCurrencyCode"
          [label]="'MasterData.TemplateSlideOver.Currency' | i18nextEager"
          [placeholder]="'Common.Placeholder' | i18nextEager"
        >
          @for (currency of currencies.value()?.data; track currency) {
            <doka-select-option
              [value]="currency.isoCurrencyCode"
              [label]="currency.isoCurrencyCode + ' - ' + currency.currencySymbol"
            ></doka-select-option>
          }
        </doka-select>

        <doka-number-input
          formControlName="cost"
          [label]="'MasterData.TemplateSlideOver.Cost' | i18nextEager"
          [unit]="
            itemTemplate()?.isoCurrencyCode
              ? getSymbolForCurrencyCode(itemTemplate()?.isoCurrencyCode)
              : userInfoService.getCurrencySymbol()
          "
          [alert]="
            form.controls.cost.touched && form.controls.cost.hasError('required')
              ? ('Common.Required' | i18nextEager)
              : ''
          "
        />
        <doka-number-input
          formControlName="lifetimeInMonths"
          [label]="'MasterData.TemplateSlideOver.Lifetime' | i18nextEager"
          [unit]="'MasterData.TemplateSlideOver.MonthsUnit' | i18nextEager"
        />
        <doka-text-field
          formControlName="deliveryTimeInMonths"
          [label]="'MasterData.TemplateSlideOver.DeliveryTime' | i18nextEager"
          [placeholder]="'MasterData.TemplateSlideOver.DeliveryTimePlaceholder' | i18nextEager"
          [alert]="
            form.controls.deliveryTimeInMonths.touched && form.controls.deliveryTimeInMonths.hasError('required')
              ? ('Common.Required' | i18nextEager)
              : ''
          "
        />

        <doka-select
          class="w-full"
          formControlName="availabilityState"
          [label]="'MasterData.TemplateSlideOver.AvailabilityState' | i18nextEager"
          [placeholder]="'Common.Select' | i18nextEager"
          [alert]="
            form.controls.availabilityState.touched && form.controls.availabilityState.hasError('required')
              ? ('Common.Required' | i18nextEager)
              : ''
          "
        >
          @for (state of availablityStateKeys; track state) {
            <doka-select-option
              [value]="state"
              [label]="'AvailabilityState.' + state | i18nextEager"
            ></doka-select-option>
          }
        </doka-select>
      </div>
    </form>
  </ng-template>
  <ng-template #footer>
    <div class="flex flex-col gap-sm w-full">
      <div class="flex w-full gap-md px-6 pt-4 items-center justify-end">
        <doka-button [disabled]="isLoading()" (click)="closeModal()" color="secondary">{{
          "Common.Cancel" | i18nextEager
        }}</doka-button>
        <doka-button type="submit" [disabled]="form.invalid || isLoading()" (click)="submit()" color="primary">{{
          "Common.Save" | i18nextEager
        }}</doka-button>
      </div>
    </div>
  </ng-template>
</doka-modal-wrapper>
